import React from 'react'
import { useMutation } from '@apollo/client'
import { Button, Input, InputNumber, Form, Row, Col, message } from 'antd'
import { UPDATE_ATTRIBUTE } from './graphql'

type Attribute = {
  label: string
  name: string
  type: 'text' | 'string' | 'number'
}

interface AttributeFieldProps {
  defaultValue?: string
  product: Product
  attribute: Attribute
  onSave?: () => void
}

const AttributeField = (props: AttributeFieldProps) => {
  const { attribute, product, defaultValue, onSave } = props
  const [form] = Form.useForm()
  const [updateProductAttribute, { loading }] = useMutation(UPDATE_ATTRIBUTE)

  let initialValues = {}

  if (defaultValue) {
    initialValues[attribute.name] = defaultValue
  }

  const onFinish = (values) => {
    if (form.validateFields()) {
      updateProductAttribute({
        variables: {
          id: product.id,
          attribute: values
        }
      })
        .then(() => {
          onSave && onSave()
          message.success(`${attribute.label} successfully saved`, 1)
        })
        .catch(() => {
          message.error(
            `Unable to save ${attribute.label}. Please try again later`,
            1
          )
        })
    }
  }

  return (
    <Row>
      <Col>
        <Form
          initialValues={initialValues}
          form={form}
          onFinish={onFinish}
          layout='vertical'
          data-testid='product-attribute-form'
        >
          <Form.Item name={attribute.name} label={attribute.label}>
            {attribute.type === 'text' ? (
              <Input.TextArea
                autoFocus
                required
                rows={5}
                cols={80}
                data-testid='product-attribute-form-input'
              />
            ) : attribute.type === 'number' ? (
              <InputNumber
                type={attribute.type}
                required
                min={0}
                data-testid='product-attribute-form-input'
              />
            ) : (
              <Input
                type={attribute.type}
                required
                data-testid='product-attribute-form-input'
              />
            )}
          </Form.Item>
          <Button
            type='primary'
            htmlType='submit'
            loading={loading}
            data-testid='product-attribute-form-submit-btn'
          >
            Save
          </Button>
        </Form>
      </Col>
    </Row>
  )
}

export default AttributeField
